import 'components/modals/account_limit_free_modal';
import 'components/modals/account_not_confirm_modal';
import 'components/modals/login_register_modal';
import 'components/modals/oab_freemium_redirect_modal';
import 'components/modals/question_belt_block_modal';
import 'components/modals/questions_limit_modal';
import 'components/modals/session_expired_modal';
import AccountLimitFreeModal from 'components/modals/account_limit_questions_modal';
import LoginRegister from 'utils/login_register';
import ModalManager from 'utils/modal_manager';
import NotSubscribedUserModal from 'components/modals/not_subscribed_user_modal';
import applyCountdown from 'utils/countdown';
import { captureProenemQuestionContextFromElement } from 'utils/proenem_setup_redirect_context';

const feedbacks = {
  utils: {
    block(event = new Event(null)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    openModal(modal) {
      ModalManager.open(`#${modal}`);
    },
    getEventResourceLimitSlug(resource) {
      const eventSlug = {
        question_comments: 'question commentaries',
        question_statistics: 'question statistics',
        question_teacher: 'commented_feedback'
      };

      return eventSlug[resource];
    }
  },
  buildLimitModal: function (dataKey) {
    const modalSeletor = 'js-account-limit-free-modal';
    const $modalBody = $(`#${modalSeletor} .modal-content`);
    const data = $modalBody.data(dataKey);
    const imageFallback = $modalBody.data('imageFallback');

    $modalBody.find('a').attr('href', data.cta_link);

    $(`#${modalSeletor} .js-benefits-list`)
      .find('li p')
      .each(function (index) {
        $(this).html(data.args[index]);
      });

    if ($modalBody.find('[data-modal-image]')) {
      $modalBody
        .find('[data-modal-image]')
        .attr('src', data?.image ?? imageFallback);
    }

    this.createCloseModalEventProxy(modalSeletor, dataKey);

    ModalManager.populate(`#${modalSeletor}`, {
      username: currentUser.name,
      title: data.title,
      description: data.description,
      'btn-text': data.btn_text,
      'cta-text': data.cta_text
    });

    const $title = $(`#${modalSeletor} [data-title]`);

    if ($title.length > 0) {
      $title.attr('aria-label', data.title);
    }

    this.utils.openModal(modalSeletor);
    applyCountdown({
      selector: `#${modalSeletor} .countdown`,
      template: '%H:%M:%S'
    });
  },

  buildBlockQuestionBeltModal() {
    applyCountdown({
      selector: '#js-question-belt-block-modal .limit-countdown',
      template: '%H:%M:%S'
    });

    this.createCloseModalEventProxy('js-question-belt-block-modal');

    this.utils.openModal('js-question-belt-block-modal');
  },

  createCloseModalEventProxy(modalSelector, key) {
    $(`#${modalSelector}`)
      .off('hidden.bs.modal')
      .on('hidden.bs.modal', () => {
        const { showOnQuestionLimitation, showOnModalRestriction, active } =
          gon.flags.trial_settings;

        if (
          key === 'modal-questions-content' &&
          active &&
          showOnQuestionLimitation
        ) {
          window.openTrialModal('question_limitation');
        }

        if (
          modalSelector === 'js-question-belt-block-modal' &&
          active &&
          (showOnQuestionLimitation || showOnModalRestriction)
        ) {
          window.openTrialModal('question_limitation');
        }

        if (key === 'modal-restriction' && active && showOnModalRestriction) {
          window.openTrialModal('modal_restriction');
        }
      });
  },

  account(event, url = location.pathname, data) {
    const questionEl = event?.currentTarget?.closest?.('.js-question');
    captureProenemQuestionContextFromElement(questionEl);
    LoginRegister.newLoginModal(url, data);
    this.utils.block(event);
  },

  confirmed_account(event) {
    this.utils.openModal('js-account-not-confirm-modal');
    this.utils.block(event);
  },

  createNotebookLimit(event) {
    this.buildLimitModal('modal-notebooks-content');

    this._sendAnalytics({ 'resource limited': 'notebooks' });
    this.utils.block(event);
  },

  practiceTestLimit(event) {
    this.buildLimitModal('modal-practice-tests-content');

    this._sendAnalytics({ 'resource limited': 'practice tests' });
    this.utils.block(event);
  },

  saveFilterLimit(event) {
    this.buildLimitModal('modal-stored-filters-content');

    this._sendAnalytics({ 'resource limited': 'stored filers' });
    this.utils.block(event);
  },

  resolveQuestionLimit(event) {
    this.buildLimitModal('modal-questions-content');

    this._sendAnalytics({ 'resource limited': 'questions' });
    this.utils.block(event);
  },

  viewCommentaryLimit(event) {
    this.buildLimitModal('modal-question-commentaries-content');

    this._sendAnalytics({ 'resource limited': 'question commentaries' });
    this.utils.block(event);
  },

  printQuestionsLimit(event) {
    this.buildLimitModal('modal-questions-print-content');

    this._sendAnalytics({ 'resource limited': 'question printing' });
    this.utils.block(event);
  },

  subscription(event) {
    const allowedEvents = ['per_page', 'sort', 'commented_feedback'];

    if (!allowedEvents.includes(event?.detail?.type)) {
      return;
    }
    new NotSubscribedUserModal(
      '#js-not-subscribed-user-modal',
      event.detail.type
    );

    this.createCloseModalEventProxy(
      'js-not-subscribed-user-modal',
      'modal-restriction'
    );

    this.utils.block(event);
  },

  trial(event) {
    const allowedEvents = ['commented_feedback'];

    if (!allowedEvents.includes(event?.detail?.type)) {
      return;
    }
    new NotSubscribedUserModal(
      '#js-not-subscribed-user-modal',
      event.detail.type
    );

    this.utils.block(event);
  },

  questionsLimitModal(event, options = {}) {
    const $oab = $('#js-oab-freemium-redirect-modal');

    // The Damásio modal only fits OAB students answering an OAB question, since
    // the redirect hands the question off to Janus, which only knows OAB content.
    // User eligibility is decided server-side (`data-eligible`); the question
    // itself is flagged per answer via `isOabQuestion`. Anyone else keeps the
    // shared generic limit modal untouched.
    if ($oab.data('eligible') === true && options.isOabQuestion === true) {
      $oab
        .find('#cta-oab-freemium-damasio')
        .attr('data-question-id', options.questionId ?? '')
        .attr('data-answer', options.answer ?? '');
      this.utils.openModal('js-oab-freemium-redirect-modal');
      // `modal variant` distinguishes this Damásio variant from the generic
      // limit modal in Amplitude, so views (not just clicks) are measurable.
      this._sendAnalytics({
        'resource limited': 'questions',
        'modal variant': 'oab damasio redirect'
      });
      this.utils.block(event);
      return;
    }

    const copyExperiment = this._questionsLimitCopyExperiment();
    const isConversionVariant = copyExperiment.variant === 'test';

    this.flexibleLimitModal(event, {
      ...(isConversionVariant
        ? this._conversionQuestionsLimitCopy()
        : this._controlQuestionsLimitCopy()),
      resourceType: 'questions',
      copyVariant: copyExperiment.variant,
      trackDailyLimitPopup: true
    });
  },

  _questionsLimitCopyExperiment() {
    const flag =
      (typeof gon !== 'undefined' &&
        gon.flags?.experiment_questions_limit_copy) ||
      {};

    if (!flag.active) {
      return { active: false, variant: 'control' };
    }

    return {
      active: true,
      variant: flag.variant === 'test' ? 'test' : 'control'
    };
  },

  _controlQuestionsLimitCopy() {
    return {
      title: 'Continue praticando!',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        'Você chegou ao limite do plano gratuito, isso mostra o quanto você está <strong>comprometido com seu futuro</strong>.',
      ctaText: 'Desbloquear acesso ilimitado',
      supportText:
        'Assine um plano ilimitado e <strong>estude</strong> sem interrupções.',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=questions_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg',
      showBenefits: false
    };
  },

  _conversionQuestionsLimitCopy() {
    return {
      title: 'Continue praticando sem interrupções',
      description:
        'Seu limite diário gratuito acabou. Com o <strong>Plano Avançado</strong>, você destrava tudo o que precisa para manter seu ritmo de estudos.',
      message: 'Menos de R$ 1 por dia investidos na sua aprovação',
      ctaText: 'Desbloquear acesso e continuar',
      ctaSubText: 'Toque para ver o valor final',
      supportText:
        '🛡️ Teste por 7 dias sem compromisso. Cancele online quando quiser.',
      dismissText:
        'Prefiro pausar meus estudos por 24h e esperar o limite renovar',
      ctaUrl: 'https://www.qconcursos.com/l/popup-limite-rdr',
      showBenefits: true,
      benefits: [
        { icon: '🎯', text: 'Questões ilimitadas com gabaritos comentados' },
        { icon: '🧠', text: '+2.000 mapas mentais para memorização rápida' },
        { icon: '📚', text: 'Apostilas digitais e videoaulas completas' },
        {
          icon: '📊',
          text: 'Relatórios de concorrência e simulados semanais'
        }
      ]
    };
  },

  newQuestionLimitModal(event) {
    this.utils.openModal('js-account-limit-questions-modal');
    this._sendAnalytics({ 'resource limited': 'questions' });
    const newQuestionLimitModal = new AccountLimitFreeModal();
    newQuestionLimitModal.load();
    this.utils.block(event);
  },

  flexibleLimitModal(event, options = {}) {
    this.utils.openModal('js-questions-limit-modal');

    const $modal = $('#js-questions-limit-modal');
    const copyVariant = options.copyVariant || 'control';
    const isConversionVariant = copyVariant === 'test';

    $modal
      .toggleClass('is-conversion-variant', isConversionVariant)
      .attr('data-variant', copyVariant);

    // This modal is shared by every flexible limit (comments, commented
    // feedback, lessons). Only the daily questions limit is under experiment,
    // so mark it explicitly — and clear the mark on every other opening, since
    // the element is reused across them.
    if (options.trackDailyLimitPopup) {
      $modal.attr('data-track-daily-limit', 'true');
    } else {
      $modal.removeAttr('data-track-daily-limit');
    }

    if (options.title) {
      $modal.find('.js-modal-title').html(options.title);
    }

    if (options.description) {
      $modal.find('.js-modal-description').html(options.description);
    }

    if (Object.prototype.hasOwnProperty.call(options, 'message')) {
      $modal.find('.js-modal-message').html(options.message || '');
    }

    const $benefits = $modal.find('.js-modal-benefits');

    if (Array.isArray(options.benefits)) {
      $benefits.empty().append(
        options.benefits.map(benefit => {
          const $item = $('<li>');

          if (benefit.icon) {
            $item.append($('<span class="benefit-icon">').text(benefit.icon));
          }

          return $item.append(document.createTextNode(benefit.text))[0];
        })
      );
    }

    if (options.showBenefits) {
      $benefits.prop('hidden', false);
    } else {
      $benefits.prop('hidden', true);
    }

    if (Object.prototype.hasOwnProperty.call(options, 'supportText')) {
      $modal.find('.js-modal-support-text').html(options.supportText);
    } else {
      $modal
        .find('.js-modal-support-text')
        .html(
          'Assine um plano ilimitado e <strong>estude</strong> sem interrupções.'
        );
    }

    if (options.ctaUrl) {
      $modal.find('#cta-questions-limit-modal').attr('href', options.ctaUrl);
    }

    if (options.ctaText) {
      const $cta = $modal.find('.btn-primary');

      if (options.ctaSubText) {
        $cta
          .empty()
          .append($('<span class="cta-label">').text(options.ctaText))
          .append($('<span class="cta-sublabel">').text(options.ctaSubText));
      } else {
        $cta.text(options.ctaText);
      }

      const $dismiss = $modal.find('.js-modal-dismiss');

      if (options.dismissText) {
        // The conversion copy asks for a plain text link, without the icon the
        // other flexible limits use.
        $dismiss.empty().append(document.createTextNode(options.dismissText));
      } else {
        $dismiss.html(
          '<i class="q-icon q-icon-times"></i> Interromper ritmo de estudo'
        );
      }
    } else if (options.resourceType) {
      this.customizeModalButtons($modal, options.resourceType);
    }

    const analyticsData = {
      'resource limited': options.resourceType || 'generic'
    };

    if (options.trackDailyLimitPopup) {
      analyticsData['modal variant'] = copyVariant;
      analyticsData.variant = copyVariant;
    }

    this._sendAnalytics(analyticsData);

    if (options.trackDailyLimitPopup) {
      this._sendDailyLimitPopupAnalytics(
        'daily limit popup viewed',
        copyVariant
      );
    }

    this.utils.block(event);
  },

  customizeModalButtons($modal, resourceType) {
    const buttonTexts = {
      'question commentaries': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      'commented feedback': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      'classes - question belt': {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      },
      questions: {
        cta: 'Desbloquear acesso ilimitado',
        link: 'Interromper ritmo de estudo'
      }
    };

    const texts = buttonTexts[resourceType];

    if (texts) {
      $modal.find('.btn-primary').text(texts.cta);
      $modal
        .find('.js-modal-dismiss')
        .html(`<i class="q-icon q-icon-times"></i> ${texts.link}`);
    }
  },

  _sendDailyLimitPopupAnalytics(eventName, variant) {
    UserTracker.emit('event', {
      eventName,
      data: { variant }
    });
  },

  questionBeltBlock() {
    this.buildBlockQuestionBeltModal();
    this._sendAnalytics({ 'resource limited': 'questions' });
    this.utils.block();
  },

  premium(event) {
    this.utils.openModal('js-not-premium-user-modal');
    this.utils.block(event);
  },

  premiumPlus(event) {
    this.utils.openModal('js-not-premium-plus-user-modal');
    this.utils.block(event);
  },

  black(event) {
    this.utils.openModal('js-not-black-user-modal');
    this.utils.block(event);
  },

  unlimited(event) {
    this.utils.openModal('js-not-unlimited-user-modal');
    this.utils.block(event);
  },

  digitalUnlimited(event) {
    this.utils.openModal('js-not-digital-unlimited-user-modal');
    this.utils.block(event);
  },

  elite(event) {
    this.utils.openModal('js-not-elite-user-modal');
    this.utils.block(event);
  },

  questionBeltLimit(type) {
    this._sendAnalytics({
      'resource limited': this.utils.getEventResourceLimitSlug(type)
    });
    this.utils.block();
  },

  commented_feedback_enabled(event) {
    this.subscription(event);
    this._sendAnalytics({ 'resource limited': 'commented_feedback' });
  },

  commentsLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Você atingiu o limite de comentários',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        '<strong>Libere os comentários</strong> e veja o <strong>que a comunidade esta pensando</strong>, entendendo o <strong>porquê</strong> desse gabarito.',
      resourceType: 'question commentaries',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_comentarios_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  questionTeacherLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Você chegou ao limite de gabaritos comentados',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        '<strong>Desbloqueie a solução detalhada</strong> e aprenda o método correto para <strong>resolver essa questão</strong>.',
      resourceType: 'commented feedback',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_gabarito_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  lessonsLimitModalSimple(event) {
    this.flexibleLimitModal(event, {
      title: 'Limite de 1 aula por dia atingido!',
      description: 'Você está no ritmo certo para conquistar sua vaga',
      message:
        'Volte amanhã para ver mais aulas, ou resolva livremente <strong>assinando um plano!</strong>',
      resourceType: 'classes - question belt',
      ctaUrl:
        '/planos-de-assinatura?qtm_source=belt_aulas_odin&qtm_medium=intervencao&qtm_content=modal_limitacao&qtm_term=produto&qtm_campaign=plg'
    });
  },

  _sendAnalytics(data = {}) {
    const $bodyEl = $('body');

    let eventData = data;

    if ($bodyEl.hasClass('q-route-questions-show')) {
      eventData = {
        ...eventData,
        source_page: 'show'
      };
    }

    UserTracker.emit('event', {
      eventName: 'account limit reached',
      data: eventData
    });
  }
};

export default feedbacks;
